import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../core/authentication';
import { ToastrService } from "ngx-toastr";
import { LocalStorageService } from '../../shared/local-storage.service'

@Component({
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private toastr: ToastrService,
    private storage: LocalStorageService
  ) {
    // redirect to home if already logged in
    if (this.storage.isActiveUser()) {
      this.router.navigate(['/dashboard']);
    }
  }

  ngOnInit() {
  }
}
